<div *ngIf="environments && environments.length">
  <div class="environments">
    <mat-card *ngFor="let environment of environments" class="environment">
      <mat-card-content>
        <div>
          <label>{{ getEnvironmentName(environment.environment.environment) }}</label>
        </div>

        <mat-form-field class="defaultCuttoffDate">
          <mat-label>Cut-off Date</mat-label>
          <input matInput (ngModelChange)="changeOccurred()" [matDatepicker]="cuttoffDatePicker"
            placeholder="Choose a date & time" [(ngModel)]="environment.defaultCuttoffDate"
            [disabled]="getEnvironmentName(environment.environment.environment) == 'Latest' || !allowEdit" />
          <mat-datepicker-toggle matSuffix [for]="cuttoffDatePicker"></mat-datepicker-toggle>
          <mat-datepicker type="datetime" #cuttoffDatePicker>
            <mat-datepicker-actions>
              <button mat-button matDatepickerCancel>Cancel</button>
              <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
            </mat-datepicker-actions>
          </mat-datepicker>
          <mat-hint>{{ environment.defaultCuttoffDate | date:'mediumDate' }}</mat-hint>
          <button *ngIf="environment.defaultCuttoffDate && allowEdit" matSuffix mat-icon-button aria-label="Clear"
            (click)="clearCutoffDate(environment)">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <div *ngIf="getEnvironmentName(environment.environment.environment) != 'Latest'" class="referenceKeyCuttoffs">
          <label class="label-title">Artifact Type Cut-off Dates</label>
          <div *ngFor="let referenceKeyCuttoff of environment.referenceKeyCuttoffs; index as i"
            class="referenceKeyCuttoff">
            <mat-form-field class="referenceKeyCuttoff">
              <mat-label>Artifact Type</mat-label>
              <mat-select [(ngModel)]="referenceKeyCuttoff.query"
                [disabled]="getEnvironmentName(environment.environment.environment) == 'Latest' || !allowEdit">
                <mat-option *ngFor="let item of keyQueries" [value]="item">
                  {{item}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="defaultCuttoffDate">
              <mat-label>Cut-off Date</mat-label>
              <input matInput [matDatepicker]="referenceKeyCuttoffPicker" placeholder="Choose a date & time"
                [(ngModel)]="referenceKeyCuttoff.cuttoffDate"
                [disabled]="getEnvironmentName(environment.environment.environment) == 'Latest' || !allowEdit" />
              <mat-datepicker-toggle matSuffix [for]="referenceKeyCuttoffPicker"></mat-datepicker-toggle>
              <mat-datepicker type="datetime" #referenceKeyCuttoffPicker>
                <mat-datepicker-actions>
                  <button mat-button matDatepickerCancel>Cancel</button>
                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                </mat-datepicker-actions>
              </mat-datepicker>
              <mat-hint>{{ referenceKeyCuttoff.cuttoffDate | date:'mediumDate' }}</mat-hint>
              <button *ngIf="referenceKeyCuttoff.cuttoffDate && allowEdit" matSuffix mat-icon-button aria-label="Clear"
                (click)="referenceKeyCuttoff.cuttoffDate=null">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <button *ngIf="allowEdit" mat-icon-button aria-label="Remove"
              (click)="onRemoveReferenceKeyCutoff(environment.referenceKeyCuttoffs, i);">
              <mat-icon>remove_circle_outline</mat-icon>
            </button>
          </div>
          <div class="add">
            <button *ngIf="keyQueries.length > environment.referenceKeyCuttoffs?.length && allowEdit" mat-flat-button
              color="accent" aria-label="Add" (click)="onAddReferenceKeyCutoff(environment.referenceKeyCuttoffs);">
              <mat-icon>add</mat-icon> Add
            </button>
          </div>
        </div>

        <div *ngIf="allowEdit" [ngSwitch]="getEnvironmentName(environment.environment.environment)">
          <div *ngIf="environment.overrides.length">
            <div *ngSwitchCase="'Staging'">
              <mat-label *ngIf="!clearOverrides">Retained {{ environment.overrides.length }} Production
                artifacts at
                {{environment.retainedFromProductionDate | date:'short'}}</mat-label>
              <mat-label *ngIf="clearOverrides">This will clear {{ environment.overrides.length }} retained
                Production
                artifacts</mat-label>
              <button *ngIf="environment.retainedFromProductionDate && !clearOverrides" mat-icon-button
                (click)="removeOverrides()" title="Clear Overrides">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <div *ngSwitchCase="'Production'">
              <mat-label>{{ environment.overrides.length }} overrides</mat-label>
            </div>
            <div *ngSwitchCase="'Fallback'">
              <mat-label>{{ environment.overrides.length }} overrides</mat-label>
            </div>
          </div>
          <div *ngSwitchCase="'Staging'">
            <div *ngIf="artifactsToRetain.length > 0">
              <mat-label>This will retain {{ artifactsToRetain.length }} Production artifacts</mat-label>
            </div>
            <button *ngIf="artifactsToRetain.length == 0 && !clearOverrides" mat-flat-button color="accent"
              (click)="keepProductionArtifacts()" title="Keep Production">
              <mat-icon>done</mat-icon> Keep Production
            </button>
            &nbsp;
            <button mat-flat-button color="accent" [disabled]="!environment.defaultCuttoffDate"
              (click)="deployStaging()" title="Send to Production">
              <mat-icon>arrow_forward</mat-icon> Send to Production
            </button>
          </div>
          <button *ngSwitchCase="'Fallback'" mat-flat-button color="accent" [disabled]="!environment.defaultCuttoffDate"
            (click)="deployFallback()" title="Send to Production">
            <mat-icon>undo</mat-icon> Send to
            Production
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <mat-card>
    <mat-card-content>
      <button *ngIf="allowEdit" mat-button class="mat-flat-button" color="primary" [disabled]="!hasChanges"
        (click)="saveWithConfirmation('Are you sure you want to manually adjust the Environments?')" title="Save">
        <mat-icon>done</mat-icon> Save
      </button>
    </mat-card-content>
  </mat-card>
</div>